import { Theme } from '@mui/material/styles'

export const getStyles = (theme: Theme) => ({
  pageWrapper: {
    flexGrow: 1,
    overflow: 'hidden auto',
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(3),
  },

  title: {
    fontSize: '16px',
    fontFamily: 'Source Sans Pro SemiBold',
    marginBottom: theme.spacing(2),
  },

  svcLocTitle: {
    marginBottom: theme.spacing(1),
  },

  header: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      width: '320px',
      paddingBottom: theme.spacing(1),
      borderBottom: '1px dotted lightgray',
    },
    '& p': {
      fontSize: '18px',
      fontFamily: 'Source Sans Pro SemiBold',
    },
  },

  infoIcon: {
    width: 20,
    height: 20,
    marginLeft: theme.spacing(0.5),
    opacity: 0.6,
  },

  toolTipList: {
    margin: theme.spacing(0),
    marginLeft: theme.spacing(1),
    padding: theme.spacing(1),
    '& li:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
    '& li:last-child': {
      fontFamily: 'Source Sans Pro SemiBold',
    },
  },

  label: {
    fontSize: '18px',
    fontFamily: 'Source Sans Pro SemiBold',
  },

  matchButton: {
    margin: `${theme.spacing(2)} 0`,
    width: '100%',
  },

  unmatchButton: {
    margin: `${theme.spacing(2)} 0`,
    minWidth: '230px',
  },

  matchPair: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
  },

  arrowIcon: {
    margin: `auto ${theme.spacing(1)}`,
  },

  divider: {
    marginBottom: theme.spacing(1),
  },

  matchForm: {
    padding: theme.spacing(1.5),
    height: 'unset',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden auto',
  },

  loadingSpinner: { margin: 'auto' },

  formTopSection: {
    paddingBottom: theme.spacing(2),
    borderBottom: '1px dotted lightgray',
    marginBottom: theme.spacing(3),
  },

  searchBox: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
  },

  billToCard: {
    width: '100%',
    transition: 'background-color 0.25s ease',
    backgroundColor: `var(--backgroundColor, ${theme.palette.background.paper})`,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0),
    marginBottom: theme.spacing(2),
  },

  serviceCard: {
    width: '100%',
    padding: theme.spacing(1),
  },
})

export type MatchClasses = ReturnType<typeof getStyles>
